import styled from 'styled-components';
import { colorUsage, transitionDuration } from 'stylesheet';
import { PlusCircled } from 'theme/icons';
var CONTAINER_LEFT_OFFSET = '-66px';
var Container = styled.div.withConfig({
  displayName: "ToggleBlockToolbarstyle__Container",
  componentId: "sc-qm092s-0"
})(["position:absolute;left:", ";display:flex;align-items:center;height:40px;cursor:pointer;transition:top ", ";"], CONTAINER_LEFT_OFFSET, transitionDuration["default"]);
var OpenButton = styled(PlusCircled).withConfig({
  displayName: "ToggleBlockToolbarstyle__OpenButton",
  componentId: "sc-qm092s-1"
})(["width:33px;height:33px;&:hover path{fill:", ";}&:hover circle{stroke:", ";}"], colorUsage.blockToolbarToggleHoverForeground, colorUsage.blockToolbarToggleHoverForeground);
export { Container, OpenButton };